<template></template>

<script>
export default {
    computed: {
        modifiersMap () {
            return this.$props.modifiers.map(modifier => { 
                if (modifier) {
                    return { [this.$options.name + '--' + modifier]: true }
                } else {
                    return false
                }
            })
        }
    }
}
</script>